// SPEC-OFFLINE-CONTINUATION-NO-ANON-01 (D-304) IMPL_7 / SPEC-OFFLINE-BADGE-FALSE-POSITIVE-01 (D-332):
//   圏外継続中の注意バッジ(表示のみ・タップ不可)。D-332 で誤検知を抑止:
//   - offline 単独ではなく offline かつ「通信が実際に届いていない兆候」の AND で描画(MDN: onLine の true は信用しない・
//     false は信用できる)。兆候 = navigator.onLine===false または 守衛が実際に 503 で止めた実績(offlineGuardHasBlocked)。
//   - pre-auth 画面(/login・/invite)では描画しない(守るべき入力データが無く、告知しても人ができることが無い)。
//   - 文言は断定でなく推定であることが伝わるヒントに(「通信できません 保存は端末内」)。色/位置/z/タップ不可は D-304 のまま不変。
import { useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { offlineGuardHasBlocked } from '../lib/auth/offlineGate'

// 未認証で入れる画面。ここには守るべき入力データが無いのでバッジを出さない(App.jsx の /login・/invite ルートと一致)。
const PRE_AUTH_PATHS = new Set(['/login', '/invite'])

export default function OfflineContinuationBadge() {
  const { offline } = useAuth()
  const { pathname } = useLocation()
  if (!offline) return null
  // FIX_1: ログイン/招待画面では出さない。
  if (PRE_AUTH_PATHS.has(pathname)) return null
  // FIX_2: 実際に通信が届いていない兆候との AND。onLine===true 単独ではバッジを消さない(captive portal 対策)。
  const commsStalled =
    (typeof navigator !== 'undefined' && navigator.onLine === false) || offlineGuardHasBlocked()
  if (!commsStalled) return null
  return (
    <div
      data-testid="offline-continuation-badge"
      role="status"
      // FIX_3: 断定でなくヒント(推定)であることが伝わる文言。
      aria-label="通信できません 端末内に保存しています オンライン復帰で自動送信します"
      // 縦位置の梯子: 巡回 top-14 / 集金 top-24 / 容量 top-32 の次段 top-40(重ねない)。z は既存と同じ [110]。
      className="fixed top-40 left-1/2 -translate-x-1/2 z-[110] px-3 py-1 rounded-full bg-sky-600/90 text-white text-xs font-bold shadow"
    >
      通信できません 保存は端末内
    </div>
  )
}
